import styles from '@hts/entities/Card/styles/InfoContent/TopButtons/TopButtons.module.scss';
import colors from '@hts/shared/styles/Colors.module.scss';
import sizes from '@hts/shared/styles/Sizes.module.scss';
import { HtsButton } from '@hts/shared/ui';
import { useMediaQuery } from '@mui/material';
import { memo } from 'react';
import { UploadLogoImage } from './UploadLogoImage';
import { UploadSecondaryImage } from './UploadSecondaryImage';

interface ITopButtonsProps {
  editAllFields: boolean;
  thereAreHiddenFields: boolean;
  canShowSecondaryImage: boolean;
  canShowLogo: boolean;
  onClickEditAllFields: () => void;
}

export const TopButtons: React.FC<ITopButtonsProps> = memo(
  ({
    editAllFields,
    thereAreHiddenFields,
    canShowLogo,
    canShowSecondaryImage,
    onClickEditAllFields,
  }) => {
    const isMobile = useMediaQuery(`(max-width: ${sizes.mobileWidth})`);

    return (
      <>
        {thereAreHiddenFields && (
          <HtsButton
            label="Edit all fields"
            variant="outlined"
            fullWidth={isMobile}
            style={{
              borderRadius: 4,
              background: !editAllFields ? 'inherit' : colors.primaryLight2,
              transition: 'background 0.3s',
              maxWidth: isMobile ? 320 : 'auto',
            }}
            className={styles.editAllFieldsButton}
            typographyProps={{ fontWeight: '500', variant: 'body2' }}
            onClick={onClickEditAllFields}
          />
        )}

        {canShowLogo && <UploadLogoImage isMobile={isMobile} />}

        {canShowSecondaryImage && <UploadSecondaryImage index={0} isMobile={isMobile} />}
      </>
    );
  }
);
